import React, {useState} from "react";
import {Button, Tooltip} from "antd";
import {EyeInvisibleOutlined, EyeTwoTone} from "@ant-design/icons";
//TODO : Add localization strings
export const HideableText = ({
    value,
    defaultHidden = false,
    specialChar = "*",
    hasTooltip = false
}) => {
    const [isHidden, setIsHidden] = useState(defaultHidden);
    const toggleHidden = () => setIsHidden(!isHidden);

    return (
        <>
            {!isHidden ? value : value.replace(/./g, specialChar)}{" "}
            <Tooltip
                title={!hasTooltip ? "" : isHidden ? "Göster" : "Gizle"}
                key={`hideable-text-${value}`}
            >
                {isHidden ? (
                    <Button icon={<EyeInvisibleOutlined />} onClick={toggleHidden} size="small" />
                ) : (
                    <Button icon={<EyeTwoTone />} onClick={toggleHidden} size="small" />
                )}
            </Tooltip>
        </>
    );
};
